import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<footer className="footer bg-primary text-white py-4">
			<div className="container">
				<div className="row">
					<div className="col-12 text-center">
						<div className="footer-links">
							<Link to="/impressum" className="text-white text-decoration-none me-4">
								Impressum
							</Link>
							<Link to="/datenschutz" className="text-white text-decoration-none">
								Datenschutz
							</Link>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
